export default __webpack_public_path__ + "static/media/ucaas-providers.db4a1757.svg";